import React, {useContext, useState} from "react";
import PropTypes from "prop-types";
import IconFB from "./icon-facebook.svg";
import IconEmail from "./icon-email.svg";
import IconSms from "./icon-sms.svg";
import { Container } from "./styles";
import {isMobile} from 'react-device-detect';
import {CommunityContext} from "../../../community/context";

// share email native window popup
const shareEmail = (body, subject, sendAnalytics) => {
  const mailToLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`;

  const elem = document.getElementById("mailto-text");
  elem.innerText = `You can manually copy the text below:\n\n ${subject}\n\n ${decodeURIComponent(body)}`;
  elem.classList.toggle('hidden');

  sendAnalytics("Share Button Clicked", {share_type: 'email', share_location_key: 'hl_community'});

  // Open the email client
  window.location.href = mailToLink;
};

const shareFacebook = (fbAppId, handle, sendAnalytics) => {
  const config = {
    method: 'share',
    href: handle,
    hashtag: '#MyHighlightsKid'
  }

  sendAnalytics("Share Button Clicked", {share_type: 'facebook', share_location_key: 'hl_community'});

  FB.ui(config, function(response){});
};

/**
 * ShareLink component
 */
const ShareLink = ({ fbAppId, handle }) => {
  const [copied, copyLink] = useState(false);
  const emailSubject = "Check out this photo of my Outdoor Adventures!";
  const emailBody = `Check out my photo of our Outdoor Adventures inspired by Tinkergarten + High Five. It’s so fun to learn and play outside! %0D%0A %0D%0A ${handle} %0D%0A %0D%0A #MyHighlightsKid #Tinkergarten`;
  const smsBody = `Check out my photo of our Outdoor Adventures inspired by Tinkergarten + High Five. It’s so fun to learn and play outside!\n\n#MyHighlightsKid #Tinkergarten\n\n${handle}`;
  const {
    actions: { sendAnalytics },
  } = useContext(CommunityContext);

  // copy handle link to clipboard
  const copyToClipboard = (sendAnalytics) => {
    const textArea = document.createElement("textarea");
    textArea.value = handle;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    copyLink(true);

    sendAnalytics("Share Button Clicked", {share_type: 'copy', share_location_key: 'hl_community'});
  };

  const shareSMS = (body, sendAnalytics) => {
    sendAnalytics("Share Button Clicked", {share_type: 'sms', share_location_key: 'hl_community'});
    // open SMS app
    window.location.href = `sms:?&body=${encodeURIComponent(body)}`;
  };

  return (
    <Container className="w-full my-6 mx-auto">
      <p className="text-center text-tgnavy text-xl font-bold font-sans">
        Share your photo via:
      </p>
      <ul className="flex justify-center m-0 list-none mb-3">
        <li className="pl-0">
          <a onClick={() => shareFacebook(fbAppId, handle, sendAnalytics)} href="#">
            <img src={IconFB} />
          </a>
        </li>

        <li className="pl-4">
          <a onClick={() => shareEmail(emailBody, emailSubject, sendAnalytics)} href="#">
            <img src={IconEmail} />
          </a>
        </li>

        {isMobile &&
            <li className="pl-4">
            <a onClick={() => shareSMS(smsBody, sendAnalytics)} href="#">
              <img src={IconSms} />
            </a>
          </li>
        }
      </ul>
      <div id="mailto-text" className="bg-tgbluelight rounded p-3 m-3 break-words hidden" />
      <div className="flex flex-col items-center justify-center">
        <p className="text-center text-tgnavy text-xl font-bold  font-sans mb-2">
          Or copy link:
        </p>
        <button
          className="copy-link flex flex-col w-full overflow-hidden"
          onClick={() => copyToClipboard(sendAnalytics)}
        >
          <span>{handle}</span>
        </button>
      </div>

      {copied && (
        <p className="text-center text-sm mt-3">Link copied to clipboard!</p>
      )}
    </Container>
  );
};

ShareLink.propTypes = {
  fbAppId: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
};

export default ShareLink;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/index.jsx